<template>

  <card title="Leads" :subtitle="subtitle">
    <div>
      <Leads-Table :toReceiveOnly="toReceiveOnly"/>
    </div>
    <!-- <div slot="footer" class="stats">
      <i class="far fa-clock"/> This Month
    </div> -->
  </card>
  
</template>

<script>
export default {
  name: 'Leads-Card',
  props: {
    toReceiveOnly: { type: Boolean, default: false }
  },
  computed: {
    subtitle () {
      var label = this.$store.getters.periodSelected ? this.$store.getters.periodSelected.label : ''
      return label ? label : ''
    }
  }
}
</script>

<style>

</style>
